import React from 'react';
import { Image } from '../Image/Image.es.js';
import '../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import 'use-callback-ref';
import 'nanoid/non-secure';
import { FeatureCardMedia } from './styled.es.js';

const Media = ({
  src,
  fallbackSrc,
  alt,
  width = 24,
  height = 24
}) => /* @__PURE__ */ React.createElement(FeatureCardMedia, null, /* @__PURE__ */ React.createElement(Image, {
  src,
  fallbackSrc,
  width,
  height,
  alt
}));
Media.displayName = "FeatureCard.Media";

export { Media };
//# sourceMappingURL=FeatureCardMedia.es.js.map
